<template>
  <v-container class="fill-height">
    <v-row>
      <v-col cols="12">
        <v-row
          align="start"
          justify="start"
          no-gutters
        >
          <v-col
            cols="2"
            sm="1"
            class="pt-1 pt-sm-0"
          >
            <LogoComponent
              :width="80"
              :height="80"
            />
          </v-col>
          <v-col
            cols="10"
            sm="11"
            class="px-3"
          >
            <v-row
              wrap
              no-gutters
            >
              <v-col cols="12">
                <p class="mb-0 f-24 sz-white--text font-weight-medium">
                  {{ title }}
                </p>
                <p
                  v-if="subtitle != null"
                  class="mb-0 text-h3 sz-white--text font-weight-medium"
                >
                  {{ subtitle }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogoComponent from '@/components/widgets/LogoComponent';
export default {
    name: 'TitleHeader',
    components: { LogoComponent },
    props: {
        title: {
            required: true,
            type: String
        },
        subtitle: {
            required: false,
            type: String,
            default: null
        }
    }
};
</script>

<style scoped>

</style>
